import { atom } from 'jotai';
import { useParams } from '@remix-run/react';
import { ECategoryNameIDMap } from 'shared/models/legacy';
import { CategoryData } from 'shared/models/feed';

export const $CategoryData = atom<CategoryData>({
  categoryName: 'foryou',
  category: ECategoryNameIDMap.foryou,
});

export const useCategoryData = (): CategoryData => {
  const { category_name } = useParams();
  const categoryName = category_name as string;
  // @ts-ignore
  const category = ECategoryNameIDMap[categoryName];

  return {
    categoryName,
    category,
  };
};
